import {
  URL_DOMAIN,
  // URL_DOMAIN_MARKET,
  getJSON,
  // URL_P2,
  requestOptionsGet,
  requestOptionsPost,
  requestOptionsPut,
  requestOptionsDelete
} from "../globals";

// const URL_FRANCHISES = URL_DOMAIN + URL_P2[0];

// const supervisorId = localStorage.getItem("fk_supervisor");

const organizationId = localStorage.getItem("fk_organization")
/**
 * Franchises
 * @returns    
 */

const getSalePointsOfOrganization = async () => {
  
  return fetch(
    URL_DOMAIN +
      "sale-point/get-sale-points?fk_organization=" +
      organizationId,
    requestOptionsGet
  ).then(getJSON);
};

const getFranchisesById = async (id) => {
  return fetch(
    URL_DOMAIN + "sale-point/get-sale-point-detail?fk_sale_point=" + id,
    requestOptionsGet
  ).then(getJSON);
};

const postFranchise = async (formData) => {
  requestOptionsPost.body = formData;
  return fetch(URL_DOMAIN  + "sale-point/create-sale-point", requestOptionsPost).then(
    getJSON
  );
};

const putFranchise = async (formData) => {
  requestOptionsPut.body = formData;
  return fetch(URL_DOMAIN + "sale-point/edit-sale-point", requestOptionsPut).then(
    getJSON
  );
};

const getFranchiseSchedule = async (id) => {
  return fetch(
    URL_DOMAIN + "sale-point/get-sale-point-schedules?fk_sale_point=" + id,
    requestOptionsGet
  ).then(getJSON);
};

const postScheduleFranchise = async (formData) => {
  requestOptionsPost.body = formData;
  return fetch(URL_DOMAIN  + "sale-point/create-sale-point-schedule", requestOptionsPost).then(
    getJSON
  );
};

const putScheduleFranchise = async (formData) => {
  requestOptionsPut.body = formData;
  return fetch(URL_DOMAIN + "sale-point/edit-sale-point-schedule", requestOptionsPut).then(
    getJSON
  );
};

const deleteScheduleFranchise = async (formData) => {
  requestOptionsPost.body = formData;
  return fetch(URL_DOMAIN  + "sale-point/delete-sale-point-schedule", requestOptionsPost).then(
    getJSON
  );
};

export { getSalePointsOfOrganization, getFranchisesById, postFranchise, putFranchise, getFranchiseSchedule, postScheduleFranchise, putScheduleFranchise, deleteScheduleFranchise };
